// material-ui
import { alpha, createTheme } from '@mui/material/styles';

// third-party

// project import
import { ThemeMode } from '@assetron/common/config/themeMode';

// types
import { PaletteThemeProps } from '@assetron/common/types/theme';
import ThemeOption from './theme';

// ==============================|| DEFAULT THEME - PALETTE ||============================== //

export default function Palette(mode: ThemeMode) {
  const paletteColor: PaletteThemeProps = ThemeOption();

  return createTheme({
    palette: {
      mode,
      common: {
        black: '#000',
        white: '#fff',
      },
      ...paletteColor,
      text: {
        primary:
          mode === ThemeMode.DARK
            ? alpha('#000'!, 0.87)
            : paletteColor.grey[700],
        secondary:
          mode === ThemeMode.DARK
            ? alpha('#000'!, 0.45)
            : paletteColor.grey[400],
        disabled:
          mode === ThemeMode.DARK
            ? alpha('#000'!, 0.1)
            : paletteColor.grey[300],
      },
      action: {
        disabled: paletteColor.grey[200],
      },
      divider:
        mode === ThemeMode.DARK ? alpha('#000'!, 0.05) : paletteColor.grey[100],
      background: {
        paper: mode === ThemeMode.DARK ? paletteColor.grey[50] : '#fff',
        default: '#fff',
      },
    },
  });
}
